module.exports = __webpack_public_path__ + "static/media/citylink-logo-transparent.7297cf09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/citylink-logo-transparent.svg
// module id = 287
// module chunks = 0